// import React, { useEffect, useState } from 'react';
import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import DarkModeBtn from '../components/DarkModeBtn';
import { useUser } from '../contexts/UserContext';
import DepositModal from '../components/DepositModal';
import LogoutButton from '../components/LogoutButton';
import BuyModal from '../components/BuyModal'; // Importar el nuevo componente BuyModal
import ProptPrice from '../components/ProptPrice';

const Dashboard2 = () => { // Cambiado de Dashboard a Dashboard2
   // const { userEmail, logout, isLoading, isAuthenticated } = useUser();
   const { userEmail, isLoading, isAuthenticated } = useUser();
   const navigate = useNavigate();
   const [isDepositModalOpen, setIsDepositModalOpen] = useState(false);
   const [initialStep, setInitialStep] = useState(1);
   const [selectedCrypto, setSelectedCrypto] = useState(null);
   const [isBuyModalOpen, setIsBuyModalOpen] = useState(false);
   const [selectedCryptoForBuy, setSelectedCryptoForBuy] = useState(null);
   const [showMore, setShowMore] = useState(false); // Agregamos este estado
   // const [kycCompleted, setKycCompleted] = useState(false);
   // const fetchKycStatus = async () => {
   //    const jwt = localStorage.getItem('jwt');
   //    const res = await fetch('https://pt-api.digit-a.net/api/steps/get-steps-status', {
   //       headers: {
   //          'Authorization': `Bearer ${jwt}`,
   //          'Content-Type': 'application/json'
   //       }
   //    });
   //    const data = await res.json();
   //    setKycCompleted(!!data.isCompleted);
   // };
   useEffect(() => {
      if (!isAuthenticated && !isLoading) {
         navigate('/sign-in');
      }
   }, [isAuthenticated, isLoading, navigate]);
   useEffect(() => {
      localStorage.removeItem('mnemonicPhrase')
   }, [])
   // useEffect(() => {
   //    fetchKycStatus();
   // }, []);
   // useEffect(() => {
   //    const interval = setInterval(() => {
   //       fetchKycStatus();
   //    }, 10000); // cada 10 segundos
   //    return () => clearInterval(interval);
   // }, []);
   // const handleLogout = () => {
   //    logout();
   //    navigate('/sign-in');
   // };
   const handleDepositClick = (e) => {
      e.preventDefault();
      setIsDepositModalOpen(true);
   };
   const handleDepositUSDClick = () => {
      setInitialStep(2);
      setIsDepositModalOpen(true);
   };
   // Función para manejar el depósito de criptomonedas
   const handleCryptoDeposit = (cryptoName, imagePath) => {
      setSelectedCrypto({
         name: cryptoName,
         image: imagePath
      });
      setInitialStep(3);
      setIsDepositModalOpen(true);
   };
   const handleBuyClick = (cryptoName, imagePath) => {
      setSelectedCryptoForBuy({
         name: cryptoName,
         image: imagePath
      });
      setIsBuyModalOpen(true);
   };
   if (isLoading) {
      return <div>Loading...</div>;
   }
   if (!isAuthenticated) {
      return null;
   }
   return (
      <div className="container-fluid max py-5" page-key="Dashboard">
         <div className="row mb-5">
            <div className="col-3">
               <NavLink to="/dashboard" className="">
                  <img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" />
               </NavLink>
            </div>
            <div className="col">
               <nav className="ppt_navdash">
                  <NavLink to="/dashboard" className="link">Wallet</NavLink>
                  <NavLink to="/propt-tokens" className="link">Propt Tokens</NavLink>
                  {/* <span className="link">Earn</span> */}
                  <NavLink to="/support" className="link">SUPPORT</NavLink>
               </nav>
            </div>
            <div className="col-auto">
               <div className="ppt_user_actions">
                  <span className="ppt_username" title={userEmail || 'Usuario'}>
                     <img src={process.env.PUBLIC_URL + '/assets/img/icon_user.svg'} data-lightmodeimg alt="ProperT User" border="0" />
                     {userEmail || 'Usuario'}
                  </span>
                  <DarkModeBtn />
                  <span className="d-flex align-items-center gap-3">
                     <NavLink to="/settings" className="">
                        <img src={process.env.PUBLIC_URL + '/assets/img/icon_settings.svg'} data-lightmodeimg alt="ProperT User" border="0" />
                     </NavLink>
                     <LogoutButton />
                  </span>
               </div>
            </div>
         </div>
         <div className="row mb-5">
            <div className="col-3 mb-4 mb-lg-0">
               <div className="ppt_header d-flex justify-content-between align-items-center">
                  <nav className="ppt_navdash_scd">
                     <NavLink to="/dashboard" className="link">Balances</NavLink>
                     <NavLink to="/activity" className="link">Activity</NavLink>
                  </nav>
               </div>
            </div>
            <div className="col d-flex gap-3 align-items-start justify-content-end">
               <NavLink
                  className="ppt_btn_secondary d-flex align-items-center gap-2"
                  to="."
                  style={{ padding: '13px 18px', fontSize: '14px' }}
               >
                  <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M5.5 13.5L5.5 1.5" stroke="#E4DC00" stroke-width="2" stroke-linejoin="round" />
                     <path d="M10 5.5L5.5 1L1 5.5" stroke="#E4DC00" stroke-width="2" stroke-linejoin="round" />
                  </svg>
                  Withdraw
               </NavLink>
               <NavLink
                  className="ppt_btn_secondary d-flex align-items-center gap-2"
                  to="."
                  onClick={(e) => handleDepositClick(e, 'USDC')}
                  style={{ padding: '13px 18px', fontSize: '14px' }}
               >
                  <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M5.5 0V12" stroke="#E4DC00" stroke-width="2" stroke-linejoin="round" />
                     <path d="M1 8L5.5 12.5L10 8" stroke="#E4DC00" stroke-width="2" stroke-linejoin="round" />
                  </svg>
                  Deposit
               </NavLink>
            </div>
         </div>
         <div className="row mb-5">
            <div className="col-auto pt-5">
               <div className="ppt_box_gen sidebar h-100">
                  <span className='ppt_box_gensb_title'>Available Balance</span>
                  <span className='ppt_box_gensb_amount'>$2,274.00</span>
                  <span className='ppt_box_gensb_graf mb-5 gap-'>
                     <svg width="215" height="215" viewBox="0 0 215 215" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_355_2)">
                           <path d="M107.508 107.508L10.8967 154.619C-15.1278 101.26 7.03717 36.9107 60.388 10.8825C75.33 3.59651 90.892 0 107.508 0V107.508Z" fill="#E4DC00" />
                           <path d="M107.508 107.508H215C215 166.881 166.873 215.015 107.508 215.015C64.7744 215.015 29.6359 193.064 10.8965 154.634L107.508 107.508Z" fill="#F7931A" />
                           <path d="M107.508 107.508L180.807 28.8806C203.39 49.9326 214.984 76.6274 214.984 107.508H107.492H107.508Z" fill="#1BA27A" />
                           <path d="M107.508 107.508L133.517 3.19348C151.946 7.78213 166.919 15.9208 180.823 28.8806L107.523 107.508H107.508Z" fill="white" />
                           <path d="M107.508 107.508V0C117.009 0 124.294 0.899127 133.517 3.19345L107.508 107.508Z" fill="white" />
                        </g>
                        <circle cx="107.5" cy="108.5" r="95.5" fill="var(--graf01)" />
                        <defs>
                           <clipPath id="clip0_355_2">
                              <rect width="215" height="215" fill="white" />
                           </clipPath>
                        </defs>
                     </svg>
                  </span>
                  <div className='ppt_box_gensb_list d-flex flex-column gap-3'>
                     <span data-color="usd"><i></i> 4% USD</span>
                     <span data-color="usdc"><i></i> 8% USDC</span>
                     <span data-color="usdt"><i></i> 13% USDT</span>
                     <span data-color="btc"><i></i> 43% BTC</span>
                     <span data-color="propt"><i></i> 32% PROPT</span>
                  </div>
               </div>
            </div>
            <div className="col">
               <div className="row mb-5 mx-auto max">
                  <div className="col">
                     <h3 className="ppt_form_title mb-3">Balances</h3>
                     <div className="ppt_box_gen">
                        <div className="d-flex align-items-center gap-4 ppt_cryptoinfo">
                           <img src={process.env.PUBLIC_URL + '/assets/img/icon_dollar.svg'} data-lightmodeimg alt="" />
                           <div className="ppt_cryptoinfo_title">
                              <span>US Dollar</span>
                              <em>$0.00</em>
                           </div>
                           <div className="ppt_cryptoinfo_name w-100">
                              <small>$1 USD = <ProptPrice /> PROPT = $1 USD</small>
                              <small>All your USD, PROPT and USDC funds are displayed here as one combined balance.</small>
                              <small>Use them interchangeably on the ProperT platform and withdraw funds anytime as any of these assets.</small>
                           </div>
                           <div className="ppt_cryptoinfo_actions">
                              <NavLink
                                 to="."
                                 className="ppt_btn_primary ms-auto alt"
                                 onClick={(e) => {
                                    e.preventDefault();
                                    handleDepositUSDClick();
                                 }}
                              >
                                 Deposit USD
                              </NavLink>
                              <NavLink to="." className="ppt_btn_secondary ms-auto alt">Withdraw USD</NavLink>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="row mb-5 mx-auto max">
                  <div className="col-12">
                     <h3 className="ppt_form_title mb-3">Supported Crypto</h3>
                  </div>
                  <div className="col">
                     <div className="ppt_box_gen">
                        <div className="d-flex align-items-start gap-4 ppt_cryptoinfo">
                           <img src={process.env.PUBLIC_URL + '/assets/img/icon_usdc.svg'} alt="" />
                           <div className="ppt_cryptoinfo_title">
                              <span>USDC</span>
                              <small>Price <em>$1.00</em></small>
                              <small>Value <em>$200.00</em></small>
                           </div>
                           <div className="d-flex flex-column ms-auto" style={{ width: '100%', maxWidth: '182px' }} >
                              <span className="d-flex gap-2 mb-2">
                                 <NavLink
                                    style={{ fontSize: '14px' }}
                                    className="w-100 mx-0 ppt_btn_primary alt"
                                    to="."
                                    onClick={(e) => {
                                       e.preventDefault();
                                       handleCryptoDeposit('USDC', '/assets/img/icon_usdc.svg');
                                    }}
                                 >
                                    Deposit
                                 </NavLink>
                                 <NavLink style={{ fontSize: '14px' }} className="w-100 mx-0 ppt_btn_secondary alt" to=".">Send</NavLink>
                              </span>
                              <span className="d-flex gap-2">
                                 <NavLink
                                    style={{ fontSize: '14px' }}
                                    className="w-100 mx-0 ppt_btn_primary alt bg-success text-white"
                                    to="."
                                    onClick={(e) => {
                                       e.preventDefault();
                                       handleBuyClick('USDC', '/assets/img/icon_usdc.svg');
                                    }}
                                 >
                                    Buy
                                 </NavLink>
                                 <NavLink style={{ fontSize: '14px' }} className="w-100 mx-0 ppt_btn_primary alt bg-danger text-white" to=".">Sell</NavLink>
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col">
                     <div className="ppt_box_gen">
                        <div className="d-flex align-items-start gap-4 ppt_cryptoinfo">
                           <img src={process.env.PUBLIC_URL + '/assets/img/icon_usdt.svg'} alt="" />
                           <div className="ppt_cryptoinfo_title">
                              <span>USDT</span>
                              <small>Price <em>$1.00</em></small>
                              <small>Value <em>$300.00</em></small>
                           </div>
                           <div className="d-flex flex-column ms-auto" style={{ width: '100%', maxWidth: '182px' }} >
                              <span className="d-flex gap-2 mb-2">
                                 <NavLink
                                    style={{ fontSize: '14px' }}
                                    className="w-100 mx-0 ppt_btn_primary alt"
                                    to="."
                                    onClick={(e) => {
                                       e.preventDefault();
                                       handleCryptoDeposit('USDT', '/assets/img/icon_usdt.svg');
                                    }}
                                 >
                                    Deposit
                                 </NavLink>
                                 <NavLink style={{ fontSize: '14px' }} className="w-100 mx-0 ppt_btn_secondary alt" to=".">Send</NavLink>
                              </span>
                              <span className="d-flex gap-2">
                                 <NavLink
                                    style={{ fontSize: '14px' }}
                                    className="w-100 mx-0 ppt_btn_primary alt bg-success text-white"
                                    to="."
                                    onClick={(e) => {
                                       e.preventDefault();
                                       handleBuyClick('USDT', '/assets/img/icon_usdt.svg');
                                    }}
                                 >
                                    Buy
                                 </NavLink>
                                 <NavLink style={{ fontSize: '14px' }} className="w-100 mx-0 ppt_btn_primary alt bg-danger text-white" to=".">Sell</NavLink>
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="row mx-auto max">
                  <div className="col-12">
                     <h3 className="ppt_form_title mb-3">Stablecoins Balance</h3>
                  </div>
                  <div className="col-6 mb-4">
                     <div className="ppt_box_gen">
                        <div className="d-flex align-items-start gap-4 ppt_cryptoinfo">
                           <img src={process.env.PUBLIC_URL + '/assets/img/icon_btc.svg'} alt="" />
                           <div className="ppt_cryptoinfo_title">
                              <span>BTC Bitcoin</span>
                              <small>Last Price <em>$7.320.75</em></small>
                              <small>Last 24hr <em className="text-danger">-0.54%</em></small>
                              <small>Value <em>$990.00</em></small>
                           </div>
                           <div className="d-flex flex-column ms-auto" style={{ width: '100%', maxWidth: '182px' }} >
                              <span className="d-flex gap-2 mb-2">
                                 <NavLink
                                    style={{ fontSize: '14px' }}
                                    className="w-100 mx-0 ppt_btn_primary alt"
                                    to="."
                                    onClick={(e) => {
                                       e.preventDefault();
                                       handleCryptoDeposit('Bitcoin', '/assets/img/icon_btc.svg');
                                    }}
                                 >
                                    Deposit
                                 </NavLink>
                                 <NavLink style={{ fontSize: '14px' }} className="w-100 mx-0 ppt_btn_secondary alt" to=".">Send</NavLink>
                              </span>
                              <span className="d-flex gap-2">
                                 <NavLink
                                    style={{ fontSize: '14px' }}
                                    className="w-100 mx-0 ppt_btn_primary alt bg-success text-white"
                                    to="."
                                    onClick={(e) => {
                                       e.preventDefault();
                                       handleBuyClick('Bitcoin', '/assets/img/icon_btc.svg');
                                    }}
                                 >
                                    Buy
                                 </NavLink>
                                 <NavLink style={{ fontSize: '14px' }} className="w-100 mx-0 ppt_btn_primary alt bg-danger text-white" to=".">Sell</NavLink>
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-6 mb-4">
                     <div className="ppt_box_gen">
                        <div className="d-flex align-items-start gap-4 ppt_cryptoinfo">
                           <img src={process.env.PUBLIC_URL + '/assets/img/icon_eth.svg'} alt="" />
                           <div className="ppt_cryptoinfo_title">
                              <span>ETH Ethereum</span>
                              <small>Last Price <em>$7.320.75</em></small>
                              <small>Last 24hr <em className="text-danger">-0.54%</em></small>
                              <small>Value <em>$684.00</em></small>
                           </div>
                           <div className="d-flex flex-column ms-auto" style={{ width: '100%', maxWidth: '182px' }} >
                              <span className="d-flex gap-2 mb-2">
                                 <NavLink
                                    style={{ fontSize: '14px' }}
                                    className="w-100 mx-0 ppt_btn_primary alt"
                                    to="."
                                    onClick={(e) => {
                                       e.preventDefault();
                                       handleCryptoDeposit('Ethereum', '/assets/img/icon_eth.svg');
                                    }}
                                 >
                                    Deposit
                                 </NavLink>
                                 <NavLink style={{ fontSize: '14px' }} className="w-100 mx-0 ppt_btn_secondary alt" to=".">Send</NavLink>
                              </span>
                              <span className="d-flex gap-2">
                                 <NavLink
                                    style={{ fontSize: '14px' }}
                                    className="w-100 mx-0 ppt_btn_primary alt bg-success text-white"
                                    to="."
                                    onClick={(e) => {
                                       e.preventDefault();
                                       handleBuyClick('Ethereum', '/assets/img/icon_eth.svg');
                                    }}
                                 >
                                    Buy
                                 </NavLink>
                                 <NavLink style={{ fontSize: '14px' }} className="w-100 mx-0 ppt_btn_primary alt bg-danger text-white" to=".">Sell</NavLink>
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className='col-12 text-center' style={{ display: showMore ? 'none' : 'flex' }}>
                     <span
                        className='ppt_showmore_options mx-auto pointer'
                        onClick={() => setShowMore(!showMore)}
                     >
                        <svg
                           width="41"
                           height="14"
                           viewBox="0 0 41 14"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <path d="M1 1L20.5 13L40 1" stroke="white" />
                        </svg>
                     </span>
                  </div>
                  <div className="col-6" hidden={!showMore}>
                     <div className="ppt_box_gen">
                        <div className="d-flex align-items-start gap-4 ppt_cryptoinfo">
                           <img src={process.env.PUBLIC_URL + '/assets/img/icon_pol.svg'} alt="" />
                           <div className="ppt_cryptoinfo_title">
                              <span>POL Polygon</span>
                              <small>Last Price <em>$7.320.75</em></small>
                              <small>Last 24hr <em className="text-danger">-0.54%</em></small>
                              <small>Value <em>$990.00</em></small>
                           </div>
                           <div className="d-flex flex-column ms-auto" style={{ width: '100%', maxWidth: '182px' }} >
                              <span className="d-flex gap-2 mb-2">
                                 <NavLink
                                    style={{ fontSize: '14px' }}
                                    className="w-100 mx-0 ppt_btn_primary alt"
                                    to="."
                                    onClick={(e) => {
                                       e.preventDefault();
                                       handleCryptoDeposit('Polygon', '/assets/img/icon_pol.svg');
                                    }}
                                 >
                                    Deposit
                                 </NavLink>
                                 <NavLink style={{ fontSize: '14px' }} className="w-100 mx-0 ppt_btn_secondary alt" to=".">Send</NavLink>
                              </span>
                              <span className="d-flex gap-2">
                                 <NavLink
                                    style={{ fontSize: '14px' }}
                                    className="w-100 mx-0 ppt_btn_primary alt bg-success text-white"
                                    to="."
                                    onClick={(e) => {
                                       e.preventDefault();
                                       handleBuyClick('Polygon', '/assets/img/icon_pol.svg');
                                    }}
                                 >
                                    Buy
                                 </NavLink>
                                 <NavLink style={{ fontSize: '14px' }} className="w-100 mx-0 ppt_btn_primary alt bg-danger text-white" to=".">Sell</NavLink>
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-6" hidden={!showMore}>
                     <div className="ppt_box_gen">
                        <div className="d-flex align-items-start gap-4 ppt_cryptoinfo">
                           <img src={process.env.PUBLIC_URL + '/assets/img/icon_propt_n.svg'} alt="" />
                           <div className="ppt_cryptoinfo_title">
                              <span>PROPT ProperT</span>
                              <small>Last Price <em>$7.320.75</em></small>
                              <small>Last 24hr <em className="text-danger">-0.54%</em></small>
                              <small>Value <em>$684.00</em></small>
                           </div>
                           <div className="d-flex flex-column ms-auto" style={{ width: '100%', maxWidth: '182px' }} >
                              <span className="d-flex gap-2 mb-2">
                                 <NavLink
                                    style={{ fontSize: '14px' }}
                                    className="w-100 mx-0 ppt_btn_primary alt"
                                    to="."
                                    onClick={(e) => {
                                       e.preventDefault();
                                       handleCryptoDeposit('ProperT', '/assets/img/icon_propt_n.svg');
                                    }}
                                 >
                                    Deposit
                                 </NavLink>
                                 <NavLink style={{ fontSize: '14px' }} className="w-100 mx-0 ppt_btn_secondary alt" to=".">Send</NavLink>
                              </span>
                              <span className="d-flex gap-2">
                                 <NavLink
                                    style={{ fontSize: '14px' }}
                                    className="w-100 mx-0 ppt_btn_primary alt bg-success text-white"
                                    to="."
                                    onClick={(e) => {
                                       e.preventDefault();
                                       handleBuyClick('PROPT', '/assets/img/icon_propt_n.svg');
                                    }}
                                 >
                                    Buy
                                 </NavLink>
                                 <NavLink style={{ fontSize: '14px' }} className="w-100 mx-0 ppt_btn_primary alt bg-danger text-white" to=".">Sell</NavLink>
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <DepositModal
            isOpen={isDepositModalOpen}
            onClose={() => {
               setIsDepositModalOpen(false);
               setInitialStep(1);
               setSelectedCrypto(null);
            }}
            initialStep={initialStep}
            initialCrypto={selectedCrypto}
         />
         <BuyModal
            isOpen={isBuyModalOpen}
            onClose={() => {
               setIsBuyModalOpen(false);
               setSelectedCryptoForBuy(null);
            }}
            cryptoType={selectedCryptoForBuy}
         />
      </div>
   );
};
export default Dashboard2; // También actualizado aquí